import type { TransactionOperation } from "."
import { shiftIsDownState } from "../../inputs"
import { nodeSelectionState_INTERNAL } from "../nodeSelection"

export const tryToDropSelection: TransactionOperation = (transactors) => {
  const { get, reset } = transactors
  const shiftIsDown = get(shiftIsDownState)
  if (!shiftIsDown) reset(nodeSelectionState_INTERNAL)
}
